require('./bootstrap');
require('./banners');
require('./controlador');
require('./creditos');
require('./menu');
require('./inputmask');

window.mayusculas=function (event){
    var key = event.keyCode;
    console.log(key);
    return ((key >= 65 && key <= 90) || key == 8 || key == 32 || key == 9 || (key >= 35 && key <= 40) || key == 46);
}

// texto auxiliar cuando se usa un select muestra una descripcion
window.helpText = function () {
    var selectedOption = $(this).find('option:selected');
    var helpTextId = selectedOption.data('help');
    $('.help-text').hide(); // Hide all help text
    if (helpTextId) {
        $('#' + helpTextId).show(); // Show the corresponding help text
    }
}

// Los niveles del menú principal
window.submenu=function(menu) {
    var target = menu.attributes.target.value;
    var level = menu.attributes.level.value;
    var isvisible = $("#"+target).hasClass("isvisible");
    
    $(".submenu[level='" + level + "']").removeClass("isvisible");
    $(".openSub[level='" + level + "']").removeClass("opened");
    if(!isvisible){
        $(menu).addClass("opened");
        $("#" + target).addClass("isvisible");
        $(".submenu[level='" + level + "']").removeClass("opened");
    }else{
        $(".openSub[level='" + level + "']").removeClass("opened");
        $("#" + target).removeClass("isvisible");
    }
}

window.calcularPrecioConIva = function() {
    var tarifa = $("#tarifa").val().replace(/_.{1,}|\,{1,}/, "");
    $("#precioConIva").html("$" + (tarifa * ($("#impuesto").val() / 100 + 1)).toFixed(2));
    
    var tarifaSencillo = $("#tarifaSencillo").val().replace(/_.{1,}|\,{1,}/, "");
    $("#precioConIvaSencillo").html("$" + (tarifaSencillo * ($("#impuesto").val() / 100 + 1)).toFixed(2));
}
window.compraDeshabilitada = function(chk) {
    if (chk.checked) {
        $(".compraDeshabilitada .clipCheckoutButton")
            .css("pointer-events", "all")
            .css("filter", "none");
    } else {
        $(".compraDeshabilitada .clipCheckoutButton")
            .css("pointer-events", "none")
            .css("filter", "grayscale(1)");
    }
}
window.copyTextToClipboard=function(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}
   
window.showSunset=function(scroll){
    // console.log(
    //     scroll + window.innerHeight,
    //     $("footer").position().top+200
    // );
    if(
        scroll + window.innerHeight>
        $("footer").position().top + (window.innerHeight/4)*3
    ){
        if (!$("footer").hasClass("show-sunset")){
            $("footer").addClass("show-sunset")
            $("body").css("background-color", "#d9582e");
            $("body").css("transition", "4s");
        }
    }else{
        if ($("footer").hasClass("show-sunset")) {
            $("footer").removeClass("show-sunset")
            $("body").css("background-color", "#f8fafc");
            $("body").css("transition", "1s");
        }
    }
}

$(document).ready(function(){
    Inputmask({ "mask": "[+99 ](999) 999 9999" }).mask(".input-telefono"); // validacion (/^(\+[0-9]{2}\x20)?\([0-9]{3}\)+\x20([0-9]{3})+\x20[0-9]{4}/).test($("#tel2").val())
    Inputmask("decimal", {
        radixPoint: '.',
        inputtype: "text"
    }).mask("input.dineros");

    // $("input.dineros") //.inputmask({ regex: "\$[0-9]{1,}\.([0-9]{2,2})||00?" })
    //     .focus(function () {
    //         if (this.value == "00.00") {
    //             this.value = "";
    //         }
    //     })
    //     .blur(function () {
    //         if (this.value == "") {
    //             this.value = "00.00";
    //         } else {
    //             this.value = parseFloat(this.value).toFixed(2);
    //         }
    //     });
    $(window).scroll(function () {
        showSunset($(this).scrollTop());
    });
});